import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'socketIdToLabel'
})
export class SocketIdToLabelPipe implements PipeTransform {
  transform(value: string) {
    if (value) {
      return 'Ja';
    } else {
      return 'Nein';
    }
  }
}
